import { Stack } from "@mui/material";
import TransactionFilters from "../filters/TransactionFilters";
import TransactionTable from "../tables/TransactionTable";

function Transactions() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <TransactionFilters/>
            <TransactionTable/>
        </Stack>
    );
}

export default Transactions;